export default __webpack_public_path__ + "static/media/allinone.48093299.png";